import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { TokenService } from './token.service';


@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(
    private authService: AuthenticationService,
    private tokenService: TokenService
  ) { }

  login(username: string, password: string): Observable<boolean> {
    return this.authService.login(username, password);
  }

  logout() {
    return this.authService.logout();
  }


  returnToTargetPage(): void {
    this.authService.redirectToTarget();
  }

  getAccessCode(): string {
    return this.tokenService.getToken().access;
  }
}
